import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoFilterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_filter"}/>
}
